import { gql } from '@apollo/client';
import TENANT_SUPPLIER from 'api/fragments/TENANT_SUPPLIER';
const GET_CURRENT_TENANT_SUPPLIERS = gql `
  ${TENANT_SUPPLIER}
  query GetCurrentTenantSuppliers(
    $first: Int
    $after: String
    $isPublic: Boolean
    $name: String
    $statusId: String
    $productCategoryId: [ID]
  ) {
    me {
      id
      currentTenant {
        id
        suppliers(
          first: $first
          after: $after
          isPublic: $isPublic
          name: $name
          status: $statusId
          products_CategoryId: $productCategoryId
        ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...TenantSupplierFragment
            }
          }
        }
      }
    }
  }
`;
export default GET_CURRENT_TENANT_SUPPLIERS;
